import React from "react";
import { Container , Row , Col } from "react-bootstrap";
import ReadMore from "../../CommonUI/ReadMoreBtn/ReadMore";
import Fox from "../../../Images/fox.png";
import Ourtools from "../../../Images/tools/our-tools-2.png";
import "./FoxTrader.css";
import { useNavigate } from "react-router-dom";
function FoxTrader(){
    let navigate = useNavigate();
    const routeChangeFox = () => {
        let path = `../FoxTrader`;
        navigate(path);
    };
    return(
        <>  
            <section className="ToolHead">
                <Container>
                    <Row className="align-items-center">
                        <Col className="col-md-6">
                            <h2 class="toolhead">Our Tools</h2>
                            <p class="tool-subhead">Market move fast, It takes seamlessly integrated and <br></br>high performance trading tools to stay ahead.</p>
                        </Col>
                        <Col className="col-md-6">
                        <img class="img-fluid out-tools-img" src={Ourtools} alt="Ourtools-tool" className="img-fluid"></img>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section className="fox-box">
                <Container className="blue-border">
                    <Row className="align-items-center ">
                        <Col md={7} sm={12} xs={12}>
                            <div className="tool-detail">
                                <h2>Fox Trader</h2>
                                <p>Powerful Charting software, where you can backtest your strategies for successful trading with 200+ conditions. </p>
                                <p>Check real-time price and volume information of stock, futures, options and commodities with an emphasis on low latency, accurate real time analysis, dependable historic data and intuitive visual interfaces.</p>
                                <span onClick={routeChangeFox}>    
                                    <ReadMore name="Know" />
                                </span>
                            </div>
                        </Col>
                        <Col md={5} sm={12} xs={12} className="text-center">
                            <img src={Fox} alt="tradetron-tool" className="img-fluid"></img>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}
export default FoxTrader;